<template>
  <figure class="flex flex-col w-full bg-white shadow-md rounded-br-3xl rounded-3xl overflow-hidden hover:shadow-none transform transition duration-200">
    <div class="w-full aspect-w-16 aspect-h-9" :class="{ 'rounded-br-3xl rounded-bl-3xl': !subtitle }" v-html="videoCode"></div>
    <h6 v-if="subtitle" class="bg-white text-xs sm:text-base py-3 px-4 sm:py-4 md:px-12 leading-tight">{{ subtitle }}</h6>
  </figure>
</template>

<script setup lang="ts">
defineProps({
  videoCode: { type: String, required: true },
  subtitle: { type: String, required: false, default: undefined },
})
</script>
